import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { IconMessage, InfoBaseIcon, MplButton, MplModal } from '@mopla/ui';

interface IProps {
	open: boolean;
	onSubmit: VoidFunction;
	onCancel: VoidFunction;
}

export const PasswordlessLoginModal: FC<IProps> = ({
	open,
	onSubmit,
	onCancel,
}) => {
	const { t } = useTranslation('logIn');

	return (
		<MplModal
			open={open}
			testId="PasswordlessLoginModal-MplModal"
			title={t('passwordless.header.main')}
			content={
				<Stack gap={3}>
					<Typography variant="body1">
						{t('passwordless.text.description')}
					</Typography>

					<IconMessage
						icon={<InfoBaseIcon />}
						message={t('passwordless.text.additional_text')}
					/>
				</Stack>
			}
			buttons={
				<>
					<MplButton fullWidth onClick={onSubmit}>
						{t('passwordless.button.submit')}
					</MplButton>
					<MplButton fullWidth onClick={onCancel} variant="outlined">
						{t('passwordless.button.reject')}
					</MplButton>
				</>
			}
		/>
	);
};
